const INLINE_ELEMENTS_DELIMITER = ',';

export class RowsHelper
{
    /**
     * Возвращаем массив элементов из строки
     * @param data
     * @return string[]
     */
    static getArrayFromString(data)
    {
        if (!data) {
            return [];
        }

        return data
            .replace(/\r\n/g,"\n")
            .split("\n")
            .map(item => item.trim())
            .filter(item => item !== "");
    }

    /**
     * Возвращаем кол-во элементов из строки
     * @param data
     * @return {number}
     */
    static getCountFromString(data)
    {
        if (!data) {
            return 0;
        }

        return this.getArrayFromString(data).length;
    }

    /**
     * Получаем строку из массива
     * @param data
     * @return {string}
     */
    static getStringFromArray(data)
    {
        return data.join("\r\n");
    }

    /**
     * Получаем строку из CSV
     * @param dataCsv
     * @return {string}
     */
    static getStringFromCsv(dataCsv)
    {
        const rows = dataCsv.replace(/\r\n/g,"\n").split('\n');
        let result = '';

        for (const row of rows) {
            const values = row.split(';');
            result += values.shift() + "\r\n";
        }

        return result;
    }
}
